import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSearchParams, useOutletContext } from 'react-router-dom';
import PCEManager from '../../components/pce/PCEManager';

const PCEDashboardPage = () => {
  const [searchParams] = useSearchParams();
  const targetAccountId = searchParams.get('account_id');
  const { userProfile, session } = useOutletContext();

  const [allpces, setAllpces] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    if (!session?.access_token || !userProfile) return;

    setLoading(true);
    try {
      const isAdmin = userProfile.rang === 0;
      
      if (isAdmin) {
        // Chargement des PCE et des clients en parallèle
        const [pceResponse, clientResponse] = await Promise.all([
          // ✅ CORRECTION : URL relative
          fetch('/api/pce/admin/all', { 
            headers: { 'Authorization': `Bearer ${session.access_token}` }
          }),
          // ✅ CORRECTION : URL relative
          fetch('/api/pce/admin/clients', { 
            headers: { 'Authorization': `Bearer ${session.access_token}` }
          })
        ]);

        const pceResult = await pceResponse.json(); 
        const clientResult = await clientResponse.json();
        
        if (pceResult.success) setAllpces(pceResult.data); 
        if (clientResult.success) setClients(clientResult.data);
        
        if (!pceResult.success) {
            throw new Error(pceResult.message || "Erreur de chargement des PCE"); 
        }

      } else {
        // Comportement standard pour les non-admins
        // ✅ CORRECTION : URL relative
        const pceResponse = await fetch('/api/pce/', { 
          headers: { 'Authorization': `Bearer ${session.access_token}` }
        });
        
        const pceResult = await pceResponse.json(); 
        
        if (pceResult.success) { 
          setAllpces(pceResult.data); 
        } else {
          throw new Error(pceResult.message || "Erreur de chargement des PCE");
        }
      }
    } catch (error) {
      console.error("Erreur lors du chargement des données PCE:", error);
      setAllpces([]); 
      setClients([]);
    } finally {
      setLoading(false);
    }
  }, [session?.access_token, userProfile]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  
  const filteredPces = useMemo(() => {
    const isTargetingAccount = !!targetAccountId;
    const isAdmin = userProfile?.rang === 0 || userProfile?.app_role === 'admin';
    
    if (isAdmin && isTargetingAccount) {
      return allpces.filter(pce => pce.account_id === targetAccountId); 
    }
    return allpces;
  }, [targetAccountId, allpces, userProfile?.rang, userProfile?.app_role]);

  return (
    <div className="space-y-4 p-3">

      {loading ? (
        <div className="text-center p-6 bg-white rounded-lg shadow-sm">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto mb-2"></div>
          <p className="text-sm">Chargement des pce...</p>
        </div>
      ) : (
        <PCEManager
          pces={filteredPces}
          onRefresh={fetchData}
          userProfile={userProfile}
          session={session}
          clients={clients}
          targetClientId={targetAccountId}
        />
      )}
    </div>
  );
};

export default PCEDashboardPage;